import { Modal } from '@odin-labs/components';
import { LinkIcon } from 'components/icons';
import React from 'react';

type ConnectorSetupDrawerLayoutProps = {
  isOpen: boolean;
  title: string;
  loading: boolean;
  actionEnabled: boolean;
  actionText?: string;
  onAction: () => Promise<void>;
  onClose: () => void;
  onBack: () => void;
  children: React.ReactNode;
};

export function ConnectorSetupDrawerLayout({
  isOpen,
  title,
  loading,
  actionEnabled,
  actionText = 'Connect',
  onAction,
  onClose,
  onBack,
  children,
}: ConnectorSetupDrawerLayoutProps): React.ReactElement {
  return (
    <Modal
      open={isOpen}
      setOpen={(open) => !open && onClose()}
      overlayCloseDisabled={loading}
      variant="drawer"
      size="sm"
      title={title}
      onAction={onAction}
      actionText={actionText}
      actionIcon={LinkIcon}
      actionButtonEnabled={actionEnabled && !loading}
      actionButtonWithSpinner={loading}
      showBackButton
      onBack={onBack}
      cancelText="Back"
    >
      {children}
    </Modal>
  );
}
